var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoveHere = function SvgMoveHere(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.958 11.038a1 1 0 0 1 1-1h40a1 1 0 0 1 1 1v15.308a1 1 0 0 1-1 1h-40a1 1 0 0 1-1-1zm2 1v13.308h38V12.038z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.958 31.346a1 1 0 0 0-1 1v.957h1v.043h1v-2zM51.958 32.346a1 1 0 0 0-1-1h-1v2h1v-.043h1zM9.958 47.654a1 1 0 0 0 1 1h1v-2h-1v.043h-1zM50.958 48.654a1 1 0 0 0 1-1v-.957h-1v-.043h-1v2zM54.344 39.293a1 1 0 0 0 0 1.414l6.364 6.364a1 1 0 0 0 1.414-1.414L57.465 41h11.46a1 1 0 1 0 0-2h-11.46l4.657-4.657a1 1 0 0 0-1.414-1.414z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.958 52.654a1 1 0 0 0-1 1v15.308a1 1 0 0 0 1 1h40a1 1 0 0 0 1-1V53.654a1 1 0 0 0-1-1zm1 15.308V54.654h38v13.308z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.958 31.346h-2v2h2zM19.958 31.346h-2v2h2zM23.958 31.346h-2v2h2zM27.958 31.346h-2v2h2zM31.958 31.346h-2v2h2zM35.958 31.346h-2v2h2zM39.958 31.346h-2v2h2zM43.958 31.346h-2v2h2zM47.958 31.346h-2v2h2zM51.958 37.13v-1.914h-2v1.914zM9.958 35.216v1.914h2v-1.914zM9.958 39.043v1.914h2v-1.914zM51.958 40.957v-1.914h-2v1.914zM51.958 44.784V42.87h-2v1.914zM9.958 42.87v1.914h2V42.87zM13.958 48.654h2v-2h-2zM17.958 48.654h2v-2h-2zM21.958 48.654h2v-2h-2zM25.958 48.654h2v-2h-2zM29.958 48.654h2v-2h-2zM33.958 48.654h2v-2h-2zM37.958 48.654h2v-2h-2zM41.958 48.654h2v-2h-2zM45.958 48.654h2v-2h-2z"
  })));
};
export default SvgMoveHere;